import { api } from "@/lib/api";
import type { Me } from "./types";

/** Full-page navigation, not fetch: it ends at Microsoft's sign-in page. */
export const SIGN_IN_URL = "/api/v1/session/login";

export const sessionApi = {
  me: () => api.get<Me>("/me"),
  logout: () => api.post<void>("/session/logout"),
};

export const sessionKeys = {
  me: ["session", "me"] as const,
};
